const cardItems = [
  {
    title: '昔日顶流被曝遭品牌方集体解约，商业帝国一夜崩塌',
    summary: '据知情人士透露，该艺人近期因私生活争议导致多个代言品牌紧急叫停合作，涉及金额或超亿元。17吃瓜黑料网持续关注事件进展。',
    badge: '独家',
    badgeColor: 'bg-primary-500',
    imagePrompt: 'A dramatic scene of broken luxury brand logos and fallen billboards in a dark city landscape, cinematic lighting with warm amber spotlights, moody atmosphere, editorial photography style, high contrast, deep shadows, no people visible, symbolic representation of brand crisis',
  },
  {
    title: '两位顶流小花被扒出私下竟是好闺蜜，粉丝们都震惊了',
    summary: '社交平台互动细节被网友深挖，多处同款穿搭与同城IP重合，两人此前从未公开互动。明星爆料持续更新中。',
    badge: '深挖',
    badgeColor: 'bg-accent-500',
    imagePrompt: 'Two elegant silhouette figures standing back to back in soft warm spotlight, luxurious fashion aesthetic, mysterious atmosphere with diffused golden light, editorial photography, shallow depth of field, dreamy bokeh background, sophisticated composition',
  },
  {
    title: '选秀节目选手被曝与导师有不正当关系，节目组回应',
    summary: '匿名投稿人提供多张聊天记录截图，17吃瓜爆料团队已向相关方求证。目前节目方表示正在内部调查中。',
    badge: '求证中',
    badgeColor: 'bg-secondary-500',
    imagePrompt: 'A television studio set in darkness with a single bright spotlight on an empty judge chair, dramatic theatrical atmosphere, warm amber and cool shadow contrast, editorial photography with cinematic noir style, symbolic emptiness and tension',
  },
  {
    title: '网红直播间惊现不雅内容，平台连夜封禁账号',
    summary: '某百万粉丝网红在直播过程中出现严重事故，引发网友大量举报。网红黑料追踪报道，事件仍在发酵中。',
    badge: '突发',
    badgeColor: 'bg-primary-500',
    imagePrompt: 'A glowing smartphone screen on a dark desk surrounded by scattered notification alerts, dramatic red and amber lighting, tense atmosphere, editorial tech-noir photography style, shallow depth of field, digital chaos symbolism',
  },
  {
    title: '业内大咖曝娱乐圈黑料潜规则，多名艺人被点名',
    summary: '资深制片人在访谈中揭露内幕吃瓜，涉及选角、商务分成等多个环节。17c吃瓜黑料爆料已整理完整时间线。',
    badge: '深度',
    badgeColor: 'bg-accent-500',
    imagePrompt: 'An intense interview scene with dramatic side lighting casting long shadows, warm amber tones contrasting with deep darkness, editorial photography, cinematic composition, anonymous source atmosphere, high contrast black and warm amber palette',
  },
  {
    title: '当红组合成员疑被公司雪藏，粉丝联合声援引热议',
    summary: '组合官方账号已三个月未更新该成员动态，引发粉丝大规模维权行动。吃瓜爆料最新进展每日追踪。',
    badge: '追踪',
    badgeColor: 'bg-secondary-500',
    imagePrompt: 'Thousands of glowing support light sticks arranged in a heart shape in darkness, warm golden illumination against deep shadows, emotional atmosphere, editorial concert photography style, symbolic fan solidarity, dramatic wide composition',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1160px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            热门爆料
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 最新深度报道</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-background-200 to-background-300">
                <div className="absolute inset-0 flex items-center justify-center">
                  <i className="ri-image-line text-4xl text-background-300"></i>
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-md text-[10px] md:text-xs font-bold text-background-50 whitespace-nowrap ${item.badgeColor}`}>
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.summary}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/50 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i> 17吃瓜爆料
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line"></i> 2小时前
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}